import { useEffect, useMemo, useState } from "react";
import { ProgramType } from "data/programData";
import useFetch from "./useFetch";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import useGetBlankTaskData, {
  setDataWithEditorKeyAndTranslationVersion,
} from "./useGetBlankTaskData";
import { getLastShownIndex, getTaskIdFromTaskKey } from "logic/logics";
import { getPublishedTaskEditorProgram } from "pages/task-editor/taskEditorRuntime";

export default function useGetTaskData({ taskKey }: { taskKey: string }) {
  const [data, setData] = useState<ProgramType>();
  const user = useRecoilValue(userAtom);
  const taskId = getTaskIdFromTaskKey(taskKey);
  const isTaskEditorTask = !!getPublishedTaskEditorProgram(taskId);

  // useEffect(() => {
  //   console.log("GET TASK DATA", taskKey);
  // }, [taskKey]);

  const blankTaskData = useGetBlankTaskData({ taskKey: taskKey });
  const fetchRequest = useMemo(
    () => ({
      url: "/task/data/load",
      params: { tk: taskKey },
    }),
    [taskKey]
  );

  const [fetchedData, getData] = useFetch(fetchRequest);

  useEffect(() => {
    if (blankTaskData) {
      if (user?.accessToken && !taskKey.includes("Tool") && !isTaskEditorTask) {
        getData();
      } else {
        setData(blankTaskData);
      }
    }
  }, [blankTaskData, getData, isTaskEditorTask, taskKey, user?.accessToken]);

  useEffect(() => {
    if (fetchedData) {
      const totalData = fetchedData?.result.data;
      if (
        totalData &&
        totalData.content.length > 0 &&
        !(
          taskKey.split("-")[0] === "104" &&
          getLastShownIndex(totalData.content) === 0
        )
      ) {
        console.log("FETCH: ", totalData);
        setData(setDataWithEditorKeyAndTranslationVersion(totalData));
      } else {
        setData(blankTaskData);
      }
    }
  }, [fetchedData]);

  return {
    data,
    refetch: () => {
      if (user?.accessToken && !taskKey.includes("Tool") && !isTaskEditorTask) {
        getData();
      }
    },
  };
}
